// extracted by mini-css-extract-plugin
export default {"drawer":"wT","drawerheader":"xT","retake_quiz_bottom_bar":"yT","extra_drawer":"zT","not_answered_questions":"AT","question_ui":"BT","accordion_details":"CT","retake_quiz":"ET","accordions":"FT","accordion_root":"GT","accordion_summary_text":"HT","animation":"IT","show_animation":"JT","overflow_hidden":"KT"};
    if(module.hot) {
      // 1713211524998
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  